var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeeMgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.8 81.2V47.8C107.8 42.6 105.1 37.9 100.6 35.3L71.5999 18.6C67.0999 16 61.5999 16 57.1999 18.6L28.2999 35.3C23.7999 37.9 21.0999 42.6 21.0999 47.8V81.2C21.0999 86.4 23.7999 91.1 28.2999 93.7L57.1999 110.4C61.6999 113 67.1999 113 71.5999 110.4L100.5 93.7C105 91.1 107.8 86.3 107.8 81.2Z",
    fill: "#F6851F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8999 40.8H59.9999C58.2999 40.8 56.6999 41.7001 55.7999 43.2001L51.3999 50.9001C50.4999 52.4001 50.4999 54.3 51.3999 55.8L55.7999 63.5C56.6999 65 58.2999 65.9001 59.9999 65.9001H68.8999C70.5999 65.9001 72.1998 65 73.0998 63.5L77.4999 55.8C78.3999 54.3 78.3999 52.4001 77.4999 50.9001L73.0998 43.2001C72.1998 41.7001 70.5999 40.8 68.8999 40.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8999 67.6H59.9999C58.2999 67.6 56.6999 68.5 55.7999 70L51.3999 77.7C50.4999 79.2 50.4999 81.1 51.3999 82.6L55.7999 90.3C56.6999 91.8 58.2999 92.7 59.9999 92.7H68.8999C70.5999 92.7 72.1998 91.8 73.0998 90.3L77.4999 82.6C78.3999 81.1 78.3999 79.2 77.4999 77.7L73.0998 70C72.1998 68.5 70.5999 67.6 68.8999 67.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3 65.9L106.7 41.8C106.7 41.8 123.6 27.4 126.5 36.8C129.4 46.3 119.3 67.2 74.3 65.9Z",
    fill: "#FDC20F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2999 65.9L21.8999 41.8C21.8999 41.8 4.99995 27.4 2.09995 36.8C-0.800053 46.2 9.19995 67.2 54.2999 65.9Z",
    fill: "#FDC20F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeMgLogo1);
export default __webpack_public_path__ + "static/media/beeMG_logo-1.b5235210c71350024093c2ebf818c7ec.svg";
export { ForwardRef as ReactComponent };